export enum AppEnv {
  TEST = 'TEST', // only applies to unit tests. Cypress tests will be either dev or prod, depending where they're ran
  DEV = 'DEV',
  PROD = 'PROD',
  STAGING = 'STAGING'
}

export const isOnProduction = (): boolean =>
  typeof window !== 'undefined' && window.location.host === 'www.simscale.com'
export const isOnStaging = (): boolean =>
  typeof window !== 'undefined' && window.location.host === 'staging.simscale.com'

export const currentVersionName: string = process.env.NEXT_PUBLIC_CURRENT_VERSION as string
export const isInLocalDevelopment: boolean = process.env.NEXT_PUBLIC_SIMSCALE_ENV === 'local'
